import { CoralHandler, CoralRequest, CoralResponse } from '@amzn/ihm-js-coral-client';
import { Observable } from 'rxjs';
import { CrossFrameUtils } from '@src/utils';

export class IIBTypeScriptCoralHandler implements CoralHandler {
    public handle(request: CoralRequest): Observable<CoralResponse<any>> {
        return new Observable((observer) => {
            const crossFrameCall = 'makeIIBAjaxRequest';

            const requestHeaders = {
                ...request.getHeaderBag(),
            };

            const iIBAjaxRequestData = {
                endpoint: request.url,
                requestData: request.body || {},
                requestHeaders,
            };

            CrossFrameUtils.sendMessageToOtherFrame({
                frame: window.top,
                message: {
                    method: crossFrameCall,
                    data: iIBAjaxRequestData,
                },
            })
                .then(
                    (response: any) =>
                        new CoralResponse({
                            headers: Object.entries(requestHeaders),
                            body: response && JSON.parse(response),
                            status: 200,
                            ok: true,
                            statusText: 'OK',
                        }),
                )
                .then(observer.next.bind(observer))
                .catch(observer.error.bind(observer))
                .finally(observer.complete.bind(observer));
        });
    }
}
